export default __webpack_public_path__ + "static/media/thank-you-front.1d62cff0.png";